import classnames from 'classnames'
import { css } from 'emotion'
import { Product } from 'even-ts-static'
import * as React from 'react'
import PlaidLink from 'react-plaid-link'
import { connect } from 'react-redux'

import { connectPlaid, plaidInit, plaidModalOpen } from 'common/actions'
import { plaidEnv, plaidPublicKey } from 'embed/constants/config'

import ThemeConsumer from 'embed/components/ThemeConsumer'
import { MultiProductState } from 'embed/reducers'

const BankIcon = require('./bank.svg')
const styles = require('./styles')

export interface OwnProps {
  onConnectComplete?: () => void
}

export interface StoreProps {
  dispatchConnectPlaid: (publicToken: string) => void
  dispatchPlaidInit: () => void
  dispatchPlaidModalOpen: (isModalOpen: boolean) => void
  plaidModalOpen: boolean
}

type Props = OwnProps & StoreProps

class ConnectPlaid extends React.Component<Props> {
  onExit = () => {
    const { onConnectComplete, dispatchPlaidModalOpen } = this.props

    dispatchPlaidModalOpen(false)
    onConnectComplete?.()
  }

  onEvent = (event) => {
    const { dispatchPlaidInit, dispatchPlaidModalOpen } = this.props

    if (event === 'OPEN') {
      dispatchPlaidInit()
      dispatchPlaidModalOpen(true)
    }
  }

  onSuccess = (publicToken: string) => {
    const { dispatchConnectPlaid, dispatchPlaidModalOpen, onConnectComplete } = this.props
    dispatchConnectPlaid(publicToken)
    dispatchPlaidModalOpen(false)
    onConnectComplete?.()
  }

  render() {
    return (
      <div>
        {this.props.plaidModalOpen && <div className={styles.overlay} />}
        <ThemeConsumer>
          {({ colorPrimary, fontFamilyPrimary }) => (
            <PlaidLink
              className={classnames(
                styles.connectButton,
                css`
                  background-color: ${colorPrimary} !important;
                  font-family: ${fontFamilyPrimary};
                `,
              )}
              clientName="Even Financial"
              env={plaidEnv}
              product={['assets', 'identity']}
              publicKey={plaidPublicKey}
              onExit={this.onExit}
              onEvent={this.onEvent}
              onSuccess={this.onSuccess}
              style={{}}
            >
              <BankIcon /> Connect with your bank
            </PlaidLink>
          )}
        </ThemeConsumer>
      </div>
    )
  }
}

const mapStateToProps = (state: MultiProductState) => ({
  plaidModalOpen: state.ui.plaid.isModalOpen,
})

const mapDispatchToProps = (dispatch) => ({
  dispatchConnectPlaid: (publicToken: string) => dispatch(connectPlaid(Product.Loan, publicToken)),
  dispatchPlaidInit: () => dispatch(plaidInit(Product.Loan)),
  dispatchPlaidModalOpen: (isModalOpen: boolean) => dispatch(plaidModalOpen(isModalOpen)),
})

export default connect(mapStateToProps, mapDispatchToProps)(ConnectPlaid)
